import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
  ElementRef,
  NgZone,
  Renderer
} from "@angular/core";
import { DOCUMENT } from "@angular/common";
import {
  Router,
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from "@angular/router";

import { TranslationLoaderService } from "./common/translation-loader.service";
import { TranslateService } from "@ngx-translate/core";
// Navigation
import { NavigationService } from "./_services/navigation.service";
import { navigation } from "./navigation/navigation";
import { locale as navigationEnglish } from "./navigation/i18n/en";
import { locale as navigationVietNam } from "./navigation/i18n/vi";
// Import AuthService
import { AuthService } from "./common/auth.service";
import { Globals } from "./common/globals";
import { Consts } from "./common/const";
import { Subject } from "rxjs";
import { CoreService } from "./_services/core.service";
import { ConfigService } from "./_services/config.service";
import { loadCldr, L10n } from "@syncfusion/ej2-base";
import * as _ from 'lodash';

declare var require: any;

loadCldr(
  require("cldr-data/supplemental/numberingSystems.json"),
  require("cldr-data/main/vi/ca-gregorian.json"),
  require("cldr-data/main/vi/numbers.json"),
  require("cldr-data/main/vi/timeZoneNames.json"),
  require("cldr-data/supplemental/weekdata.json") // To load the culture based first day of week
);

L10n.load({
  vi: {
    datepicker: {
      placeholder: "Chọn ngày",
      today: "Hôm nay"
    }
  }
});

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit, OnDestroy {
  navigation: any;
  isCorrectDomain: boolean;
  isloading: boolean;

  @ViewChild("spinnerElement", { static: false })
  spinnerElement: ElementRef;

  // Private
  private _unsubscribeAll: Subject<any>;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private _translationLoaderService: TranslationLoaderService,
    private _configService: ConfigService,
    private _translateService: TranslateService,
    private _navigationService: NavigationService,
    private _router: Router,
    private globals: Globals
  ) {
    this._unsubscribeAll = new Subject();

    this._configService.loadingSubject.subscribe(data => {
      if (data === "true") {
        this.isloading = true;
      } else {
        this.isloading = false;
      }
    });

    this._router.events.subscribe((event: any) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.isloading = true;
          
          // --- Your existing permission logic (unchanged) ---
          let permissions = localStorage.getItem("permissions");
          permissions = JSON.parse(permissions);
          let lstFunctionUrls = _.map(permissions, "path");
          let urlSkip = [
            "/cms/dashboard",
            "/error/404",
            "/cms/profile",
            "/nopermission",
            "/auth/login",
            "/auth/forgot-password",
          ];

          let checkPermissionUrl = false;
          for (let i = 0; i < lstFunctionUrls.length; i++) {
            if (event.url.indexOf(lstFunctionUrls[i]) > -1) {
              checkPermissionUrl = true;
              break;
            }
          }
          var indexSkip = _.findIndex(urlSkip, (item) => {
            return event.url.indexOf(item) > -1;
          })

          if (
            indexSkip == -1 && ("/".indexOf(event.url) == -1) &&
            checkPermissionUrl === false
          ) {
            window.location.href = window.location.origin + "/auth/login";
          }
          break;
        }

        case event instanceof NavigationEnd: {
          this.isloading = false;
          
          // const currentPath =
          //   (event.urlAfterRedirects || event.url || "").split("?")[0] || "/";

          // // --- BLOCK 1: Manual Reload (from sidebar, etc.) ---
          // // This block is for your manual 'reload' flag.
          // const reloadKey = `reload-${currentPath}`;
          // const shouldReload = sessionStorage.getItem(reloadKey);
          
          // if (shouldReload === "true") {
          //   sessionStorage.removeItem(reloadKey);
            
          //   setTimeout(() => {
          //     window.location.reload();
          //   }, 100);
            
          //   break; // A reload is scheduled, stop all other logic.
          // }

          // --- BLOCK 2: NEW "Reload Once" Logic ---
          // This replaces all your old logic to prevent loops.
          
          // const lowerPath = currentPath.toLowerCase();
          
          // // Only run this logic if we are not on the root path
          // if (lowerPath && lowerPath !== "/") {
            
          //   // Create a unique key for this specific page
          //   const didReloadKey = `didReload-${currentPath}`;
          //   const didReload = sessionStorage.getItem(didReloadKey);

          //   if (didReload === 'true') {
          //     // We are on the page load *after* the reload.
          //     // We must clear the flag so the *next* navigation works.
          //     sessionStorage.removeItem(didReloadKey);
          //   } else {
          //     // This is the *first* time we landed here.
          //     // Set the flag *before* reloading.
          //     sessionStorage.setItem(didReloadKey, 'true');
              
          //     // Schedule the reload
          //     setTimeout(() => {
          //       window.location.reload();
          //     }, 100);

          //     break; // A reload is scheduled, stop processing.
          //   }
          // }

          // break;
        }
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.isloading = false;
          // Clear any flags if navigation fails
          const currentPath =
            (event.url || "").split("?")[0] || "/"; // <-- FIX: Changed to event.url
          sessionStorage.removeItem(`didReload-${currentPath}`);
          break;
        }
        default: {
          break;
        }
      }
    });

    this.navigation = navigation;
    this._navigationService.register("main", this.navigation);
    this._navigationService.setCurrentNavigation("main");
    this._translateService.addLangs(["vi", "en"]);
    this._translateService.setDefaultLang("vi");
    this._translationLoaderService.loadTranslations(
      navigationVietNam,
      navigationEnglish
    );
    this._translateService.use("vi");
  }

  /**
   * On init
   */
  ngOnInit(): void { }
  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    if (this._unsubscribeAll) {
      this._unsubscribeAll.next();
      this._unsubscribeAll.complete();
    }
  }

  // Redirect 404
  redirectNotFound(): void {
    window.location.href =
      Consts.BACKEND_PROTOCOL + this.globals.backendURL + "/errors/error-404";
  }
}